import { defineStore } from "pinia"

type Crumb = { label: string; name?: string; params?: any; query?: any }
export const useBreadcrumbStore = defineStore("breadcrumb", {
    state: () => ({
        title: null as string | null,
        description: null as string | null,
        items: [] as Crumb[],
    }),
    actions: {
        set(payload: { title?: string; description?: string; items?: Crumb[] }) {
            if (payload.title !== undefined) this.title = payload.title
            if (payload.description !== undefined) this.description = payload.description
            if (payload.items !== undefined) this.items = payload.items
        },
        clear() { this.title = null; this.description = null; this.items = [] },
    },
})
